import CategoriesMenu from './CategoriesMenu';

export default CategoriesMenu;
